<template>
  <div class="b2c-order">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="6">
            <h4>
              Danh sách tin nhắn đã gửi <a v-b-tooltip.hover.top="'Lấy lại danh sách!'" class="btn-icon"
                                           @click="$router.go()">
              <feather-icon icon="RepeatIcon"/>
            </a>
            </h4>
          </b-col>
          <b-col md="2">
            <validation-provider #default="{ errors }" :rules="''" name="Số điện thoại">
              <b-form-group :description="params.msisdn ? 'Số điện thoại nhận sms' : ''">
                <b-input-group>
                  <b-form-input v-model="params.msisdn" placeholder="Nhập số điện thoại nhận sms" size="sm"/>
                  <b-input-group-append is-text role="button" @click="quickSearch">
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="2">
            <validation-provider #default="{ errors }" :rules="''" name="Từ ngày">
              <b-form-group :description="params.from ? 'Từ ngày' : ''">
                <b-input-group>
                  <b-form-datepicker v-model="params.from"
                                     :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}"
                                     :state="errors.length > 0 ? false:null"
                                     close-button locale="vi-VN" placeholder="Chọn từ ngày"
                                     reset-button
                                     size="sm"
                                     today-button
                                     @input="quickSearch"
                  />
                </b-input-group>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="2">
            <validation-provider #default="{ errors }" :rules="''" name="Đến ngày">
              <b-form-group :description="params.to ? 'Đến ngày' : ''">
                <b-input-group>
                  <b-form-datepicker v-model="params.to"
                                     :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}"
                                     :state="errors.length > 0 ? false:null"
                                     close-button locale="vi-VN" placeholder="Chọn đến ngày"
                                     reset-button
                                     size="sm"
                                     today-button
                                     @input="quickSearch"
                  />
                </b-input-group>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Per Page -->
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="fields" :isLoading.sync="isLoading" :line-numbers="true"
                            :pagination-options="{perPage: 20,enabled: true,perPageDropdown: [20,50,100],dropdownAllowAll: false}"
                            :rows="rows"
            >
              <template
                  slot="table-row"
                  slot-scope="props"
              >
              <span>
                {{ props.formattedRow[props.column.field] }}
              </span>
              </template>
            </vue-good-table>
          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>

import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';
import moment from 'moment';
import SearchSelect from "../components/select/SearchSelect.vue";

export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BCardText,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    SearchSelect
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {
    this.loadMasterData();
  },
  watch: {
    $route(to, from) {
      this.loadMasterData();
    }
  },
  methods: {
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    quickSearch() {
      this.loadItems();
    },
    loadMasterData() {
      //this.loadItems();
    },
    loadItems() {
      this.loading(true);
      this.isLoading = true;
      useJwt.get('gapit/history', {
        params: {
          msisdn: this.params.msisdn,
          from: this.params.from,
          to: this.params.to
        }
      }).then(response => {
        this.rows = response.data.result;
        this.totalRecords = response.data.result.length();
        this.isLoading = false;
        this.loading(false);
      }).catch(error => {
        this.loading(false);
        this.isLoading = false;
      })
    },
  },
  data() {
    return {
      searchString: "",
      isLoading: false,
      totalRecords: 0,
      rows: [],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchTerm: '',
      currentItem: {},
      fields: [
        {
          field: 'source',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Hệ thống',
        },
        {
          field: 'brandname',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Brandname',
        },
        {
          field: 'msgbody',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Nội dung',
        },
        {
          field: 'status_text_vi',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Trạng thái',
        },
        {
          field: 'time_send_text',
          filterOptions: {enabled: true, placeholder: '', trigger: 'enter'},
          label: 'Thời gian',
          tdClass: 'text-right',
        }
      ],
      msisdn: "0",
      params: {
        msisdn: "",
        from: "",
        to: ""
      },
      required
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
</style>
